'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createDocumentAction = exports.createDocumentsAction = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _fetch = require('../fetch');

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var defaultHandleFetch = function defaultHandleFetch(c) {
  return {
    type: c.FETCH
  };
};

var defaultHandleSuccess = function defaultHandleSuccess(c, data) {
  return {
    type: c.FETCH_SUCCESS,
    payload: { data: data }
  };
};

var defaultHandleFailure = function defaultHandleFailure(c, error) {
  return {
    type: c.FETCH_FAILURE,
    payload: { error: error }
  };
};

var createDocumentsAction = function createDocumentsAction(namespace) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (dispatch, getState) {
    var c = {
      FETCH: namespace + '/FETCH',
      FETCH_SUCCESS: namespace + '/FETCH_SUCCESS',
      FETCH_FAILURE: namespace + '/FETCH_FAILURE'
    };

    var _options$fetch = options.fetch,
        fetch = _options$fetch === undefined ? _fetch.fetchDocuments : _options$fetch,
        _options$handleFetch = options.handleFetch,
        handleFetch = _options$handleFetch === undefined ? defaultHandleFetch : _options$handleFetch,
        _options$handleFetchS = options.handleFetchSuccess,
        handleFetchSuccess = _options$handleFetchS === undefined ? defaultHandleSuccess : _options$handleFetchS,
        _options$handleFetchF = options.handleFetchFailure,
        handleFetchFailure = _options$handleFetchF === undefined ? defaultHandleFailure : _options$handleFetchF,
        token = options.token,
        params = _objectWithoutProperties(options, ['fetch', 'handleFetch', 'handleFetchSuccess', 'handleFetchFailure', 'token']);

    dispatch(handleFetch(c));

    return fetch(_extends({}, params, {
      token: getApiToken(token, getState())
    })).then(function (data) {
      dispatch(handleFetchSuccess(c, data));
      return Promise.resolve(data);
    }).catch(function (error) {
      dispatch(handleFetchFailure(c, error));
      return Promise.reject(error);
    });
  };
};

exports.createDocumentsAction = createDocumentsAction;
var createDocumentAction = exports.createDocumentAction = function createDocumentAction(namespace, options) {
  return createDocumentsAction(namespace, _extends({}, options, {
    fetch: _fetch.fetchDocument
  }));
};

var getApiToken = function getApiToken(token, state) {
  switch (typeof token === 'undefined' ? 'undefined' : _typeof(token)) {
    case 'function':
      return token(state);
    default:
      return token;
  }
};


//////////////////
// WEBPACK FOOTER
// ../~/prismic-utils/dist/action/index.js
// module id = 1132
// module chunks = 0